module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "进度所属模块"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.ModuleId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ModuleId", $$v)
      },
      expression: "form.ModuleId"
    }
  }, _vm._l((_vm.modalTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测进度选项名"
    }
  }, [_c('el-input', {
    staticClass: "formLength",
    model: {
      value: (_vm.form.OptionTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "OptionTitle", $$v)
      },
      expression: "form.OptionTitle"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "125px",
      "text-align": "right"
    }
  }, [_vm._v("检测结果可选项：")]), _vm._v(" "), _vm._l((_vm.form.List), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '可选' + (index + 1),
        "label-width": "130px"
      }
    }, [_c('el-input', {
      staticClass: "formLength",
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAddBtnShow[index]),
        expression: "isAddBtnShow[index]"
      }],
      staticClass: "fa fa-plus-circle",
      on: {
        "click": _vm.addList
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDelBtnShow[index]),
        expression: "isDelBtnShow[index]"
      }],
      staticClass: "fa fa-minus-circle",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeList(index)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37e4a124!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/checkList/modalDialog/index.vue
// module id = 1452
// module chunks = 1